<template>
    <div class="news_select_wrap">
        <ul class="nav nav-pills">
            <li class="dropdown">
            <a tabindex="0" type="button" data-toggle="dropdown">{{type[pageKey].leaderboard}}<span class="caret"></span></a>
            <!-- role="menu": fix moved by arrows (Bootstrap dropdown) -->
            <ul class="dropdown-menu" role="menu">
                <li v-for="(bookKey, idx) in bookType.length" :key="idx" v-if="bookType[idx] !==pageKey"><a :href="'leaderboard?id='+type[bookType[idx]].id+'&type='+type[bookType[idx]].name">{{type[bookType[idx]].leaderboard}}</a></li>
                <!-- <li><a href="novel_leaderboard.php">小說排行</a></li> -->
            </ul>
            </li>
        </ul>
    </div>
</template>

<script>
import axios from 'axios'
import {API_URL, userStatus} from './config.js'
import user from './user.js'

export default {
  name: 'Dropdown',
  props: ["id"],
  data () {
    return {
      item: this.book,
      type: this.$root.bookType,
    }
  },
  methods: {
    ...user,
  },
  computed: {
    bookType: function () {
        let keys = Object.keys(this.$root.bookType)
        this.$root.removeItemFromArray(keys,'index')
        this.$root.removeItemFromArray(keys,'novel')
        return keys
    },
    pageKey: function () {
        let keys = Object.keys(this.$root.bookType)
        let locate
        keys.map(key => {
            if (this.$root.bookType[key].id == this.id) locate = key
        })
        return locate
    }
  },
  mounted () {
    // console.log('Subscribe mounted')
    // if (this.item) $('[data-remodal-id=modal-'+this.item.BookID+']').remodal()
    // $('[data-remodal-id=modal-'+this.item.BookID+']').remodal()
  }
}
</script>



// WEBPACK FOOTER //
// src/Dropdown.vue